import ThisModule from "./ModalAlert";

export default ThisModule;
